import { render } from "./CustomConfirm.vue?vue&type=template&id=a12c1dc8&scoped=true"
import script from "./CustomConfirm.vue?vue&type=script&lang=js"
export * from "./CustomConfirm.vue?vue&type=script&lang=js"

import "./CustomConfirm.vue?vue&type=style&index=0&id=a12c1dc8&scoped=true&lang=css"

import exportComponent from "/home/cpaps/sistema-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a12c1dc8"]])

export default __exports__